<div [ngClass]="{'lds-ring-small': type === 'small', 'lds-ring': type === ''}">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
